module.exports = __webpack_public_path__ + "img/icon-person-fill.b0f318a.svg";